import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  DialogTitle,
  DialogContent,
  CircularProgress,
  IconButton
} from '@material-ui/core';
import { DialogWithFocusProvider } from 'components/layout';
import { ViewCrmInfo } from 'api/revue/underwriteData';
import { appNotify } from 'store/actions';
import { TabsWrapper } from 'components/layout';
import { ViewCrmCurrent, ViewCrmHistory } from 'components/underwrite/acquisition/propertyUnderwrite/header/viewCrmTabs';
import ClearIcon from '@material-ui/icons/Clear';

const ViewCrmModal = ({ classes, open, handleClose, txnOppId }) => {
  const [crmInfo, setCrmInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (open && txnOppId) {
      setCrmInfo(null); // Reset client transaction opp before fetching
      setIsLoading(true);
      GetCrmInfo(txnOppId);
    }
  }, [txnOppId, open]);
  const GetCrmInfo = (txnOppId) => {
    ViewCrmInfo(txnOppId).then(res => {
      if (!res) {
        appNotify('Crm Info not found', 'warning');
      } else {
        setCrmInfo(res);
      }
    }).catch(error => {
      appNotify(error.message, 'error');
    }).finally(() => {
      setIsLoading(false);
    });
  }
  return (
    <DialogWithFocusProvider onClose={handleClose} open={open} className={classes.dialog} maxWidth={'lg'} fullWidth>
      <DialogTitle>
        {`CRM Information - ${txnOppId}`}
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        {isLoading ?
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress />
          </div>
          :
          (crmInfo && <TabsWrapper labels={['Current', 'History']}>
            <ViewCrmCurrent crmInfo={crmInfo.crmViewInfo} />
            <ViewCrmHistory crmInfo={crmInfo.crmViewHistories} txnOppId={txnOppId}/>
          </TabsWrapper>
          )
        }
      </DialogContent>
    </DialogWithFocusProvider>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  },
  textFieldRoot: {
    height: 70,
    marginBottom: 16,
    paddingRight: 8,
    flexBasis: '25%'
  },
  errorText: {
    lineHeight: 1
  },
  textWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  textLabel: {
    minWidth: '200px'
  },
  divider: {
    marginTop: '4px',
    marginBottom: '4px'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

const mapState = state => ({
  confirmationModalState: state.appState.confirmationModalState,
});
const mapDispatch = dispatch => ({
  appNotify: (message, variant) => dispatch(appNotify(message, variant))
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(ViewCrmModal);